import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useProductService from '../../../app/services/hooks/useProductService';

interface Props {
  productId: number;
  checkValue: boolean;
  callbackSuccess: () => void;
}

const ProductSwitchChange = ({ productId, checkValue, callbackSuccess }: Props) => {
  const { hideLoading } = useContext(AppContext);
  const [checked, setChecked] = React.useState<boolean>(checkValue);
  const { activeProduct } = useProductService();

  // ← si el valor cambia desde afuera (p.ej. recarga), sincroniza el switch
  useEffect(() => {
    setChecked(checkValue);
  }, [checkValue]);

  const active = (value: boolean) => {
    setChecked(value);
    activeProduct(productId, value, {
      onSuccess: (response: ServiceResponse) => {
        hideLoading?.();
        useReactConfirmAlert().successAlert({ title: 'Éxito', message: response.message });
        callbackSuccess();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        setChecked(!value);
        useReactConfirmAlert().errorAlert({ title: 'Error', message: response.message });
      }
    });
  };

  return <ActiveControl status={checked} id={productId} callback={active} />;
};

export default ProductSwitchChange;
